import styled from 'styled-components';

const InputGroup = styled.div`
  margin-bottom: 40px;
`;

export default InputGroup;
